module.exports = __webpack_public_path__ + "static/img/S01.3a29b0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/hongbao/S01.jpg
// module id = EdYN
// module chunks = 9